/**
 * Exception for loading timeout
 *
 * @access public
 */
class LoadingTimeoutError extends Error {
  constructor() {
    super("SEON SDK loading timed out");
    /**
     * @constant
     * @type {"LoadingTimeoutError"}
     */

    this.name = "LoadingTimeoutError";
  }

}
/**
 * Exception for initialization failure
 *
 * @access public
 */

class InitializationError extends Error {
  constructor() {
    super("SEON SDK failed to initialize");
    /**
     * @constant
     * @type {"InitializationError"}
     */

    this.name = "InitializationError";
  }

}
/**
 * Exception for fingerprint retrieval error
 *
 * @access public
 */

class FingerprintError extends Error {
  constructor() {
    super("SEON SDK failed to compute fingerprint");
    /**
     * @constant
     * @type {"FingerprintError"}
     */

    this.name = "FingerprintError";
  }

}

export { FingerprintError, InitializationError, LoadingTimeoutError };
